// extracted by mini-css-extract-plugin
module.exports = {"titleTextStyle":"titlecolumns_titleTextStyle__32A0w","titleTextStyle1":"titlecolumns_titleTextStyle1__3xTCK"};